import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBrain, FiAlertCircle, FiX } = FiIcons;

const ProblemSection = () => {
  const problems = [
    {
      icon: FiBrain,
      title: "Your brain doesn't think in straight lines",
      description: "You have 40 tabs open in your mind, three urgent projects, and a brilliant idea that just hit while you were brushing your teeth."
    },
    {
      icon: FiAlertCircle,
      title: "Existing tools feel... wrong",
      description: "They were built by people who've never had their brain ping-pong between five different thoughts in thirty seconds."
    },
    {
      icon: FiX,
      title: "You're tired of fighting your brain",
      description: "Productivity advice that works for neurotypical minds just makes you feel more broken. Spoiler: you're not."
    }
  ];

  return (
    <section id="problem" className="problem-section">
      <div className="container mx-auto px-6 py-20">
        <motion.div 
          className="section-header"
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">
            Yeah, we know. Existing tools feel like they were designed by people 
            who've never had 40 tabs open in their brain.
          </h2>
        </motion.div>
        
        <div className="problems-grid">
          {problems.map((problem, index) => (
            <motion.div 
              key={index}
              className="problem-card"
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="problem-icon">
                <SafeIcon icon={problem.icon} />
              </div>
              <h3 className="problem-title">{problem.title}</h3>
              <p className="problem-description">{problem.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;